
import { Component, Prop, Mixins } from 'vue-property-decorator';
import AvisoAlCerrar from '@/mixins/AvisoAlCerrar';
import AvisoSinGuardar from '@/components/core/AvisoSinGuardar.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import TravelSelect from '@/components/inputs/TravelSelect.vue';
import TypeAccommodationSelect from '@/components/inputs/FeatureAccommodationSelect.vue';
import AccomodationService from '@/services/AccomodationService';
import Accomodation from '@/models/accommodation';
import ApiHelper from '@/helpers/api-helper';
import FeatureSelect from '@/components/inputs/FeatureSelect.vue';
import FeatureService from '@/services/FeatureService';
import ImageUpload from '@/components/inputs/ImageUpload.vue';
import AccommodationPrices from '@/components/inputs/AccommodationPrices.vue';
import TextEditor from '@/components/inputs/TextEditor.vue';
import ProviderSelect from '@/components/inputs/ProviderSelect.vue';
import AccommodationExtraPrices from '@/components/inputs/AccommodationExtraPrices.vue';

@Component({
	components: {
		AvisoSinGuardar,
		AccommodationExtraPrices,
		ProviderSelect,
		TextEditor,
		AccommodationPrices,
		ImageUpload,
		FeatureSelect,
		TravelSelect,
		TypeAccommodationSelect,
		ValidationProvider,
		ValidationObserver,
	},
})
export default class AccomodationForm extends Mixins(AvisoAlCerrar) {
	@Prop({ default: null, required: true }) private edit_id;

	$refs!: {
		obs: InstanceType<typeof ValidationObserver>;
		accommodationPrices: InstanceType<typeof AccommodationPrices>;
	};

	private loading = false;
	private formTitle = '';
	private accomodation: Accomodation = new Accomodation();
	private feature_accomodation = FeatureService.ACCOMODATION_TYPE;
	private feature_center = FeatureService.ACOMMODATION_CENTER_DISTANCE_TYPE;

	/** N-291 (T5b): lo que GUARDAR mandaría (las tablas de precios comparten el array con el modelo). */
	loQueSeGuardaria() {
		return JSON.stringify(this.accomodation);
	}

	mounted() {
		if (this.edit_id) {
			this.loading = true;
			this.formTitle = 'Edit accommodation';
			AccomodationService.get(this.edit_id)
				.then(res => {
					if (res.status === 200) {
						this.accomodation = Accomodation.copy(res.data);
						this.loading = false;
						this.fotoSinCambios();
					}
				})
				.catch(error => {
					ApiHelper.handleErrors(error, {}, this.$bus);
				});
		} else {
			this.formTitle = 'New accommodation';
			this.fotoSinCambios();
		}
	}

	async validateFile($file,$event) {
		await this.$refs[$file].validate($event);
	}

	async create() {
		const component = this;
		const validForm = await this.$refs['obs'].validate();
		const validPrices = await this.$refs['accommodationPrices'].validate();
		if (validForm && validPrices) {
			this.loading = true;
			AccomodationService.create(this.accomodation)
				.then(res => {
					if (res.status === 201) {
						this.loading = false;
						this.$emit('saved');
					}
				})
				.catch(error => {
					this.loading = false;
					ApiHelper.handleErrors(error, component.$refs['obs'], this.$bus);
				});
		}
	}

	async update() {
		const component = this;
		const validForm = await this.$refs['obs'].validate();
		const validPrices = await this.$refs['accommodationPrices'].validate();
		if (validForm && validPrices) {
			this.loading = true;
			AccomodationService.update(this.accomodation)
				.then(res => {
					if (res.status === 200) {
						this.loading = false;
						this.$emit('saved');
					}
				})
				.catch(error => {
					this.loading = false;
					ApiHelper.handleErrors(error, component.$refs['obs'], this.$bus);
				});
		}
	}

	get isImageUploaded() {
		return typeof this.accomodation.img_url === 'string';
	}
}
